module.exports = __webpack_public_path__ + "img/ordem-decrescente.5346f328.svg";